import React from 'react';
import './Footer.less';
import { Row, Column, Item } from 'react-plan';
import { Link } from 'react-router';

type Props = {

}

class Footer extends React.Component {

  description: 'Footer.'

  props: Props

  constructor(props: Props) {
    super(props);
  }

  /* Component Custom Methods */
  /* End Component Custom Methods */

  /* React Component LifeCycle Methods */
  //componentWillMount() {}
  //componentDidMount() {}
  //componentWillReceiveProps(nextProps) {}
  //shouldComponentUpdate(nextProps, nextState) {}
  //componentWillUpdate(nextProps, nextState) {}
  //componentDidUpdate(prevProps, prevState) {}
  //componentWillUnmount() {}
  render() {
    return (
      <div className="footer">
        <div className="bg-dark-blue">
          <div className="bloc-small">
            <div className="p-t-xl p-b-xl">
                <p className="txt-center">Copyright © 2017, World Space School. All rights reserved.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
  /* End React Component LifeCycle Methods */
}

export default Footer;

//Unit test entry point
export const _Footer = Footer;


/** WEBPACK FOOTER **
 ** ./src/js/app/Footer/Footer.jsx
 **/